import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class SignIn extends Component {

	componentDidMount() {

     const $ = window.$;

     $( 'body' ).addClass( 'bg-15' );

 	}

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return <div className="signin-page-area pd-bottom-70 pd-top-70 ">
			  <div className="container">
			    <div className="row justify-content-center">
			      <div className="col-xl-6 col-lg-6">					
			        <form className="signin-inner">
					<div className="row">
			            <div className="col-12 text-center">
							<img src={publicUrl+"assets/img/masala.png"} alt="img" class="s-logo" />
						</div>
					</div>
					
					<ul class="fxt-socials">
						<li class="fxt-facebook">
							<div class="fxt-transformY-50 fxt-transition-delay-6">
								<Link to="/" title="facebook"><i class="fab fa-facebook"></i><span>Facebook</span></Link>
							</div>
						</li>
						<li class="fxt-google">
							<div class="fxt-transformY-50 fxt-transition-delay-6">
								<Link to="/" title="google"><i class="fab fa-google"></i><span>Google</span></Link>
							</div>
						</li>
						<li class="fxt-microsoft">
							<div class="fxt-transformY-50 fxt-transition-delay-6">
								<Link to="/" title="Microsoft"><i class="fab fa-microsoft"></i><span>Microsoft</span></Link>
							</div>
						</li>
						<li class="fxt-apple">
							<div class="fxt-transformY-50 fxt-transition-delay-6">
								<Link to="/" title="Apple"><i class="fab fa-apple"></i><span>Apple</span></Link>
							</div>
						</li>
					</ul>
					<p><small>You can log in using Google, Facebook, Outlook or Apple's authentication service. Or with Finnish mobile phone number. A customership is automatically created for you. You can manage the authentication services connected to your customer account from the account management settings. Orders, Reservations, receipts, etc., remain in your account.</small></p>
					<div class="fxt-style-line">
						<div class="fxt-transformY-50 fxt-transition-delay-5">
							<h3>OR</h3>
						</div>
					</div>
			          <div className="row">
			            <div className="col-12">
							<div class="input-group mb-4">
								<div class="input-group-prepend">
								<div class="input-group-text">+358</div>
								</div>
								<input type="text" class="form-control" placeholder="Enter Mobile No"/>
							</div>
			            </div>
			            <div className="col-12 mb-4">
			              <button className="btn btn-base w-100">Log In</button>
			            </div>
			            <div className="col-12 text-center">
			              <Link to="#">Go Back</Link>
			            </div>
			          </div>
			        </form>
			      </div>
			    </div>
			  </div>
			</div>
        }
}

export default SignIn